/** Переходы, которые карточка делает сама; приёмка клиентом — отдельные формы (день 30). */
export type SimpleTarget = 'at_warehouse' | 'shipped' | 'draft' | 'cancelled';

// Как TRANSITIONS в backend/app/domain/state_machine.py (только «простые» переходы).
export const SIMPLE_TARGETS: Record<string, SimpleTarget[]> = {
  draft: ['at_warehouse', 'cancelled'],
  at_warehouse: ['shipped', 'draft', 'cancelled'],
};
